import React, { Component } from 'react';
import { NavMenu } from './NavMenu';
import { Footer } from './Footer';
import { flexbox } from './Variables';

const { detect } = require('detect-browser');
const browser = detect();

export class Layout extends Component {
  displayName = Layout.name

    setStyle() {
        var style = {};
        switch (browser && browser.name) {
            case 'chrome':
                style = !this.props.isHomePage ? { display: "flex", flexDirection: "column" } : {};
                break;
            case 'firefox':
                style = !this.props.isHomePage ? { display: "flex", flexDirection: "column" } : {};
                break;
            case 'edge':
                style = !this.props.isHomePage ? { display: "flex", flexDirection: "column" } : {};
                break;
            case 'ie':
                style = !this.props.isHomePage ? { display: "flex", flexDirection: "column" } : {};
                break;
            case 'iOS':
                style = {};
                break;
            default:
                style = {};
        }
        return style;
    }

    render() {
        this.setStyle();
        var style = this.setStyle();

        const { children } = this.props;
        return (
            <div className="wrapper" style={{ height: "100%", ...style }}>
                <NavMenu logo={this.props.logo} history={this.props.history} LoggedIn={this.props.LoggedIn} Logout={(e) => this.props.Logout(e)} />
                <div className="page-body" style={flexbox}>
                        {children}
                </div>
                <Footer />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Layout.js